window.updateDrawerShippingEstimate = async function updateDrawerShippingEstimate() {
  const lineEl = document.getElementById('DrawerShippingLine');
  const valueEl = document.getElementById('DrawerShippingValue');
  const noteEl  = document.getElementById('DrawerShippingNote');
  
  if (!lineEl || !valueEl || !noteEl) return;

  const totalCents = Number(lineEl.dataset.totalCents || 0);
  const frThreshold = Number(lineEl.dataset.frThreshold || 7900);

  const formatEUR = (cents) =>
    new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);

  // Nom du pays en FR depuis ISO2
  function getCountryNameFr(iso2) {
    try {
      return new Intl.DisplayNames(['fr'], { type: 'region' }).of(iso2) || iso2;
    } catch (e) {
      const map = { FR: 'France', BE: 'Belgique', CH: 'Suisse' };
      return map[iso2] || iso2;
    }
  }

  // --- GeoIP country (Shopify) (cache 1h)
  async function getGeoIpCountryHandle() {
    const key = '__geoip_country_handle__';
    const tsKey = '__geoip_country_handle_ts__';
    const now = Date.now();
    const ts = Number(localStorage.getItem(tsKey) || 0);
    const cached = localStorage.getItem(key);

    if (cached && ts && (now - ts) < 3600 * 1000) return cached;

    const r = await fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' });
    const data = await r.json();
    const handle = String(data?.detected_values?.country?.handle || '').toUpperCase();

    if (handle) {
      localStorage.setItem(key, handle);
      localStorage.setItem(tsKey, String(now));
    }
    return handle;
  }

  let country = '';
  try { country = await getGeoIpCountryHandle(); } catch (e) { country = ''; }

  // ✅ TEST: force FR (à retirer après)
  //country = 'BE';

  const countryName = getCountryNameFr(country || 'FR');

  // Estimation seulement pour FR, BE, CH
  const ESTIMATE_COUNTRIES = new Set(['FR', 'BE', 'CH']);



  // ---------- Tarifs STANDARD par paliers de prix (en centimes)
  const ZONES = {
    // 1) France
    FR: {
      days: '4–6 jours',
      byPrice: [
        { maxCents: 1500, cents: 549 },              // 0–14,99
        { maxCents: frThreshold, cents: 759 },       // 15–58,99
        { maxCents: Infinity, cents: 0, free: true } // ≥59
      ]
    },

    // 2) Belgique + (DE, LU, AT, NL, PL, IT, PT, ES)
    EURO_PROCHE: {
      days: '4–8 jours',
      byPrice: [
        { maxCents: 5000, cents: 1499 },
        { maxCents: 10000, cents: 1950 },
        { maxCents: 20000, cents: 2200 },
        { maxCents: 50000, cents: 2800 },
        { maxCents: Infinity, cents: 2800 }
      ]
    },

    // 3) UE (votre liste)
    UE: {
      days: '4–8 jours',
      byPrice: [
        { maxCents: 5000, cents: 1499 },
        { maxCents: 10000, cents: 1950 },
        { maxCents: 20000, cents: 2200 },
        { maxCents: 45000, cents: 2800 },
        { maxCents: Infinity, cents: 2800 }
      ]
    },

    // 4) Suisse
    CH: {
      days: '4–8 jours',
      byPrice: [
        { maxCents: 5000, cents: 1499 },
        { maxCents: 10000, cents: 1939 },
        { maxCents: 20000, cents: 2200 },
        { maxCents: 50000, cents: 2800 },
        { maxCents: Infinity, cents: 2800 }
      ]
    },

    // 5) Maghreb
    MAGHREB: {
      days: '4–9 jours',
      byPrice: [
        { maxCents: 5000, cents: 2379 },
        { maxCents: 10000, cents: 2899 },
        { maxCents: 20000, cents: 3199 },
        { maxCents: Infinity, cents: 3199 }
      ]
    },

    // 6) DOM TOM
    DOMTOM: {
      days: '8–20 jours',
      byPrice: [
        { maxCents: 5000, cents: 1200 },
        { maxCents: 10000, cents: 1900 },
        { maxCents: 20000, cents: 2600 },
        { maxCents: 50000, cents: 3900 },
        { maxCents: Infinity, cents: 3900 }
      ]
    },

    // 7) Guyane
    GF: {
      days: '8–20 jours',
      byPrice: [
        { maxCents: 5000, cents: 1200 },
        { maxCents: 10000, cents: 1900 },
        { maxCents: 20000, cents: 2589 },
        { maxCents: 50000, cents: 3890 },
        { maxCents: Infinity, cents: 3890 }
      ]
    },

    // 8) International (fallback)
    INTERNATIONAL: {
      days: '8–20 jours',
      byPrice: [
        { maxCents: 5000, cents: 3519 },
        { maxCents: 10000, cents: 3919 },
        { maxCents: 20000, cents: 5399 },
        { maxCents: 50000, cents: 7869 },
        { maxCents: Infinity, cents: 7869 }
      ]
    }
  };

  // Pays -> zone
  const EURO_PROCHE_COUNTRIES = new Set(['BE','DE','LU','AT','NL','PL','IT','PT','ES']);
  const UE_COUNTRIES = new Set(['GB','SE','BG','HR','CZ','DK','EE','FI','GR','HU','LV','LT','MT','RO','SK','SI','IE']);
  const MAGHREB_COUNTRIES = new Set(['DZ','MA','TN']);
  const DOMTOM_COUNTRIES = new Set(['RE','GP','MQ','YT']);

  function getZoneKey(iso2) {
    if (iso2 === 'FR') return 'FR';
    if (iso2 === 'CH') return 'CH';
    if (iso2 === 'GF') return 'GF';
    if (EURO_PROCHE_COUNTRIES.has(iso2)) return 'EURO_PROCHE';
    if (UE_COUNTRIES.has(iso2)) return 'UE';
    if (MAGHREB_COUNTRIES.has(iso2)) return 'MAGHREB';
    if (DOMTOM_COUNTRIES.has(iso2)) return 'DOMTOM';
    return 'INTERNATIONAL';
  }

  function getStandardShippingByPrice(iso2, totalCents) {
    const zoneKey = getZoneKey(iso2);
    const zone = ZONES[zoneKey] || ZONES.INTERNATIONAL;

    const bracket = zone.byPrice.find(b => totalCents < b.maxCents) || zone.byPrice[zone.byPrice.length - 1];
    const cents = bracket.cents;
    const isFree = !!bracket.free;

    const note = isFree
      ? `Livraison gratuite (${zone.days})`
      : `Standard (${zone.days})`;

    return { cents, note, zone };
  }

 const { cents, note, zone } = getStandardShippingByPrice(country, totalCents);

 
  // Si pas d’estimation (hors FR/BE/CH), vous pouvez choisir un délai générique
  const days = zone?.days || 'délais indiqués à l’étape suivante';
  

  // Render
  if (!ESTIMATE_COUNTRIES.has(country)) {
    lineEl.hidden = false;
 valueEl.innerHTML = `Livraison ${countryName} (${days}) : tarif affiché au paiement - <a href="/policies/shipping-policy#option-transitaire-recommandee-colisexpat">Optimiser la livraison</a>`;
    noteEl.hidden = true;
    noteEl.textContent = '';
    return;
  }

  lineEl.hidden = false;
  valueEl.textContent = `Livraison ${countryName} (${days}) : ${formatEUR(cents)}`;

  noteEl.hidden = false;
  noteEl.textContent = '';
};